import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { Router, UrlTree } from '@angular/router';
import { CodaltComponent } from 'src/app/codalt.component';
import { PlanningDetailDialogService } from 'src/app/services/dialog/planning-detail-dialog.service';
import { LocalStorage } from 'src/app/storage.class';
import { TracklinePlanningEditDialogComponent } from 'src/app/trackline/pages/trackline-planning-edit-dialog/trackline-planning-edit-dialog.component';
import { Utils } from 'src/app/utils.class';
import { DayReportStateService } from '../day-report-state.service';

@Component({
    selector: 'app-day-report-nav-buttons',
    standalone: false,
    templateUrl: './day-report-nav-buttons.component.html',
})
export class DayReportNavButtonsComponent extends CodaltComponent {
    private stateService = inject(DayReportStateService);
    private planningDetailDialogService = inject(PlanningDetailDialogService);
    private dialog = inject(MatDialog);
    private router = inject(Router);

    user = LocalStorage.getUser();

    readonly planning = toSignal(this.stateService.planning$);
    readonly dayReport = toSignal(this.stateService.dayReport$);

    openPlanning(event: MouseEvent) {
        const planning = this.planning();
        if (!planning) {
            return;
        }

        if (this.opensNewTab(event)) {
            const begindate = planning.mainPlanning?.begindate;
            const commands = !begindate
                ? ['/weekplanning/behoefte', planning.id]
                : this.environment.asphaltPlanning
                  ? ['/asfaltplanning', Utils.formatDate(begindate), planning.id]
                  : [
                        '/weekplanning',
                        Utils.getWeek(new Date(begindate)),
                        new Date(begindate).getFullYear(),
                        planning.id,
                    ];
            this.navigate(this.router.createUrlTree(commands), event);
        } else if (this.environment.asphaltPlanning) {
            this.planningDetailDialogService.openPlanning(planning);
        } else {
            this.dialog.open(TracklinePlanningEditDialogComponent, {
                disableClose: true,
                panelClass: 'planning-edit-dialog',
                data: { planning },
            });
        }
    }

    print() {
        const planning = this.planning();
        if (!planning) {
            return;
        }

        const url = this.router.serializeUrl(this.router.createUrlTree(['/dagrapport-afdruk', planning.id]));
        Utils.openTab(url);
    }

    goToProcessing(event: MouseEvent) {
        const planning = this.planning();
        const dayReport = this.dayReport();
        if (!planning?.customer?.id || !dayReport?.id) {
            return;
        }

        const urlTree = this.router.createUrlTree(['/bestekprijzen/productie-tabel', planning.customer.id], {
            queryParams: { afasProjectId: planning.afas_project_id ?? null, dayreportId: dayReport.id },
        });
        this.navigate(urlTree, event);
    }

    private opensNewTab(event: MouseEvent) {
        return event.ctrlKey || event.metaKey || event.button === 1;
    }

    private navigate(urlTree: UrlTree, event: MouseEvent) {
        if (this.opensNewTab(event)) {
            Utils.openTab(this.router.serializeUrl(urlTree));
        } else {
            this.router.navigateByUrl(urlTree);
        }
    }
}
